import moment from "moment-timezone";

/**
 * Date formatting for anything the site renders from a stored timestamp.
 *
 * Formatting is pinned to Malaysia time rather than the renderer's own zone.
 * Vercel runs the server in UTC and the reader's browser runs in UTC+8, so a
 * bare `moment(ts).format(...)` turns one stored instant into two different
 * calendar days: React reports a hydration mismatch, and the prerendered HTML
 * a crawler reads carries the earlier date. It never showed in local
 * development because the machine doing the developing is already in UTC+8.
 *
 * `moment-timezone` is already a dependency and the booking-email path
 * (`pages/api/live-class/send-grid-booking-email.ts`) already pins this same
 * zone, so this makes the rest of the site consistent with what the emails
 * have always done.
 *
 * See Web Delivery Standards § 18.
 */
export const SITE_TIME_ZONE = "Asia/Kuala_Lumpur";

/** Format a stored epoch-millis timestamp as a Malaysian calendar day. */
export function formatDateMY(ts: number, format = "D MMM YYYY"): string {
  return moment.tz(ts, SITE_TIME_ZONE).format(format);
}
